<template>
	<div class="page-admins">
		<PartUserTabs/>

		<div class="admin__wrap">
			<h2 class="section-title admin__title">List of all active Admins</h2>

			<router-link v-if="checkPermissions()" class="btn btn--mid btn--icon admin__btn" id="new_admin-button" :to="{ name: 'NewAdmin' }">
				<SvgIcon class="admin__btn-icon" iconName="ico-plus"/>
				<span>Add New</span>
			</router-link>

			<router-link v-if="checkPermissions()" class="btn btn--icon admin__btn" id="deleted_admins-button" :to="{ name: 'DeletedAdmins' }">
				<SvgIcon class="admin__btn-icon" iconName="ico-trash"/>
				<span>Deleted Admins</span>
			</router-link>
			<div class="notification-wrap-side notification-wrap-side--full">
				<PartNotifications :data="notificationsData" v-if="notificationsData.msg" />
			</div>
		</div>

		<div class="table-wrap" :class="{'table-empty': noResults}">
			<BlockTable
				v-if="!noResults"
				:data="AdminsTableData"
				class="dashborad-properies-table style-table--round"
				@deleteRow="deleteRow"
				@editRow="editRow"
				@sortData="sortAdmins"
				:sort="localOrderBy"
			/>
			<PartLoaderBig class="loader-table" v-if="preloader"/>
			<PartNoResults :data="DataNoResults" v-if="noResults && !preloader"/>
			<PartPagination
				ref="pagination"
				v-show="!preloader && showPagination"
				@getPage="getPage"
			/>
		</div>

		<PartPopupDelete
			v-if="showPopupDelete"
			:data="PopupDelete"
			@confirmPopupDelete="confirmPopupDelete"
			@closePopupDelete="closePopupDelete"
		>
			<template v-slot:popupTitle>Are you sure you want to delete this admin?</template>
			<template v-slot:popupCancel>No</template>
			<template v-slot:popupConfirm>Yes</template>
		</PartPopupDelete>
	</div>
</template>
<script>
import PartPopupDelete from '@/components/parts/PartPopupDelete';
import PartUserTabs from '@/components/parts/PartUserTabs';
import BlockTable from '@/components/blocks/BlockTable';
import SvgIcon from '@/components/base/SvgIcon/SvgIcon';
import { check } from '@/services/RouteGuards/SuperAdmin';
import PartLoaderBig from '@/components/parts/PartLoaderBig';
import PartNotifications from '@/components/parts/PartNotifications';
import PartPagination from '@/components/parts/PartPagination';
import PartNoResults from '@/components/parts/PartNoResults';

export default {
	data: () => {
		return {
			classScroll: 'prevent-scroll',
			DataNoResults: {},
			noResults: true,
			notificationsData: {
				type: '',
				msg: ''
			},
			showPagination: false,
			localOrder: 'asc',
			localOrderBy: 'first_name',
			preloader: true,
			PopupDelete: {
				itemID: ''
			},
			showPopupDelete: false,
			AdminsTableData: {
				stickyHeader: true,
				noLocalSorting: true,
				noCollapse: false,
				fields: [
					{ key: 'first_name', label: 'First Name', sortable: true, stickyColumn: true, variant: 'first-name' },
					{ key: 'last_name', label: 'Last Name', sortable: true, stickyColumn: true, variant: 'last-name' },
					{ key: 'email', label: 'Email', sortable: true, stickyColumn: true, variant: 'email' },
					{ key: 'landline_phone', label: 'Landline Phone', sortable: true, stickyColumn: true, variant: 'landline-phone' },
					{ key: 'phone_ext', label: 'Phone Ext', sortable: true, stickyColumn: true, variant: 'phone-ext' },
					{ key: 'cellphone', label: 'Cellphone', sortable: true, stickyColumn: true, variant: 'cellphone' },
					{ key: 'created_at', label: 'Created', sortable: true, stickyColumn: true, variant: 'created-at' },
					{ key: 'delete_admin', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon second-icon-fixed table-fixed-icon--red last-icon-fixed' },
					{ key: 'edit', label: '', sortable: false, stickyColumn: true, variant: 'fixed-icon first-icon-fixed' }
				],
				items: []
			}
		};
	},
	components: {
		PartPopupDelete,
		BlockTable,
		SvgIcon,
		PartUserTabs,
		PartLoaderBig,
		PartNotifications,
		PartPagination,
		PartNoResults
	},
	created() {
		this.$store.dispatch('fetchAdmins').then(response => {
			this.$refs.pagination.updateDataPag(response.data);
			this.checkPagination(response.data);
		});
		this.checkPermissions();
	},
	computed: {
		admins() {
			return this.$store.getters.getAdmins;
		}
	},
	watch: {
		admins() {
			if (!this.checkPermissions()) {
				const leng = this.AdminsTableData.fields.length;
				this.AdminsTableData.fields.splice(leng - 2, 2);
			}

			this.noResults = !this.admins.length;
			this.preloader = false;
			this.AdminsTableData.items = this.admins;
		}
	},
	methods: {
		deleteAdmin(id) {
			this.$store.dispatch('deleteAdmin', id).then(response => {
				this.$store.dispatch('fetchAdmins');
				if (undefined !== response.data) {
					this.notification(response);
				}
			});
		},
		notification(response) {
			this.notificationsData.msg = response.data.message;
			this.notificationsData.type = response.status === 200 ? 'success' : 'danger';

			setTimeout(() => {
				this.notificationsData.msg = '';
				this.notificationsData.type = '';
			}, 2000);
		},
		checkPermissions() {
			return check();
		},
		deleteRow(id) {
			this.showPopupDelete = true;
			this.PopupDelete.itemID = id;
			this.$parent.$refs.app.parentNode.classList.add(this.classScroll);
		},
		editRow(id) {
			this.$router.push({ name: 'EditAdmin', params: { id: id } });
		},
		closePopupDelete() {
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		confirmPopupDelete(id) {
			this.deleteAdmin(id);
			this.showPopupDelete = false;
			this.$parent.$refs.app.parentNode.classList.remove(this.classScroll);
		},
		fetchNewActiveAdmins(obj) {
			setTimeout(() => {
				this.preloader = true;
			}, 100);

			return this.$store.dispatch('fetchNewActiveAdmins', obj);
		},
		sortAdmins(item) {
			const obj = {
				order_by: item,
				order: this.SortOrder(item),
				page: 1
			};
			this.localOrderBy = item;
			this.fetchNewActiveAdmins(obj).then(response => {
				this.$refs.pagination.updateDataPag(response.data);
			});
		},
		SortOrder(item) {
			if (this.localOrderBy === item) {
				if (this.localOrder === 'asc') {
					this.localOrder = 'desc';
				} else {
					this.localOrder = 'asc';
				}
			} else {
				this.localOrder = 'asc';
			}
			return this.localOrder;
		},
		getPage(page, $ref) {
			const obj = {
				order_by: this.localOrderBy,
				order: this.localOrder,
				page: page
			};
			this.fetchNewActiveAdmins(obj).then(response => {
				$ref.updateDataPag(response.data);
			});
		},
		checkPagination(data) {
			this.showPagination = data.prev_page_url !== null || data.next_page_url !== null;
		}
	}
};
</script>
<style lang="scss" scoped>
.page-admins {
	padding: 43px 43px 43px 15px;

	@include mq(1200px) {
		max-width: 100%;
		padding: 43px 15px;
	}

	@include mq($xl) {
		padding: 20px 0;
	}
}

.admin__wrap {
	display: flex;
	align-items: center;
	margin-bottom: 20px;
	flex-wrap: wrap;

	@include mq($md) {
		justify-content: center;
	}

	@include mq(400px) {
		flex-direction: column;
	}
}

.admin__title {
	margin-right: 25px;
	margin-bottom: 0;
	display: inline-block;

	@include mq($md) {
		flex: 0 0 100%;
		max-width: 100%;
		text-align: center;
		margin-bottom: 15px;
		margin-right: 0;
	}
}
.admin__btn {
	margin-right: 20px;

	&:last-of-type {
		margin-right: 0;
	}

	@include mq(400px) {
		margin-right: 0;
		margin-bottom: 10px;
	}
}
.admin__btn-icon {
	margin-right: 5px;
	height: 19px;

	svg {
		height: 14px;
	}
}
.admin__title {
	margin-right: 25px;

	@include mq($md) {
		margin-right: 0;
	}
}
.table-wrap {
	min-height: 64vh;
}
</style>
